export const getPercentage = (value, total) => {
	value = parseFloat(value).toFixed(2);
	total = parseFloat(total).toFixed(2);
	return ((value / total) * 100).toFixed(2);
};
